export { getGlobalValue } from "./getGlobalValue";

declare global {
  interface Window {
    REAPackageVersions?: Record<string, string[]>;
  }
}
if (typeof window === "object") {
  window.REAPackageVersions = window.REAPackageVersions || {};
  window.REAPackageVersions["@rea-argonaut/global-store"] =
    window.REAPackageVersions["@rea-argonaut/global-store"] || [];
  window.REAPackageVersions["@rea-argonaut/global-store"].push(
    "__@rea-argonaut/global-store/version__",
  );
}
